(function () {
  const sectionSelector = '[data-pandalino-product-gallery]';
  const zoomMediaQuery = window.matchMedia(
    '(min-width: 990px) and (hover: hover) and (pointer: fine)'
  );

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function resetZoom(mediaEl) {
    mediaEl.classList.remove('is-hover-zoomed');
    mediaEl.style.setProperty('--pandalino-zoom-x', '50%');
    mediaEl.style.setProperty('--pandalino-zoom-y', '50%');
  }

  function bindHoverZoom(section) {
    section.querySelectorAll('.product__media--static').forEach((mediaEl) => {
      if (mediaEl.dataset.pandalinoZoomBound === 'true') return;
      mediaEl.dataset.pandalinoZoomBound = 'true';
      resetZoom(mediaEl);

      mediaEl.addEventListener('pointerenter', () => {
        if (!zoomMediaQuery.matches) return;
        mediaEl.classList.add('is-hover-zoomed');
      });

      mediaEl.addEventListener('pointermove', (event) => {
        if (!zoomMediaQuery.matches) return;

        const rect = mediaEl.getBoundingClientRect();
        if (!rect.width || !rect.height) return;

        const x = clamp(((event.clientX - rect.left) / rect.width) * 100, 0, 100);
        const y = clamp(((event.clientY - rect.top) / rect.height) * 100, 0, 100);

        mediaEl.style.setProperty('--pandalino-zoom-x', `${x}%`);
        mediaEl.style.setProperty('--pandalino-zoom-y', `${y}%`);
      });

      mediaEl.addEventListener('pointerleave', () => resetZoom(mediaEl));
      mediaEl.addEventListener('pointercancel', () => resetZoom(mediaEl));
    });
  }

  function bindAfterChange($mainSlider) {
    $mainSlider.off('afterChange.pandalinoGallery').on('afterChange.pandalinoGallery', function () {
      if (typeof window.pauseAllMedia === 'function') {
        window.pauseAllMedia();
      }
    });
  }

  function reinitProductGallerySlider(section) {
    if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.slick !== 'function') {
      return;
    }

    const $section = window.jQuery(section);
    const $mainSlider = $section.find('.product__media-list').first();
    const $thumbSlider = $section.find('.product__media-sublist').first();

    if (!$mainSlider.length) return;

    if ($thumbSlider.length && $thumbSlider.hasClass('slick-initialized')) {
      $thumbSlider.slick('unslick');
    }

    if ($mainSlider.hasClass('slick-initialized')) {
      $mainSlider.slick('unslick');
    }

    const mainSettings = Object.assign({}, getSliderSettings(), {
      infinite: false,
    });

    if ($thumbSlider.length) {
      mainSettings.asNavFor = $thumbSlider;
    }

    $mainSlider.slick(mainSettings);
    bindAfterChange($mainSlider);

    if ($thumbSlider.length) {
      const thumbSettings = Object.assign({}, getSubSliderProductSettings($mainSlider), {
        infinite: false,
      });
      $thumbSlider.slick(thumbSettings);
    }
  }

  function initSection(section) {
    reinitProductGallerySlider(section);
    bindHoverZoom(section);
  }

  function initAllSections() {
    document.querySelectorAll(sectionSelector).forEach(initSection);
  }

  function initSectionFromVariantEvent(event) {
    const sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) {
      window.requestAnimationFrame(initAllSections);
      return;
    }

    const shopifySection = document.getElementById(`shopify-section-${sectionId}`);
    const section = shopifySection && shopifySection.querySelector(sectionSelector);

    window.requestAnimationFrame(() => {
      if (section) {
        initSection(section);
      } else {
        initAllSections();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.requestAnimationFrame(initAllSections);
  });

  document.addEventListener('variant:change', initSectionFromVariantEvent);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches(sectionSelector)
      ? event.target
      : event.target.querySelector(sectionSelector);

    window.requestAnimationFrame(() => {
      if (section) {
        initSection(section);
      }
    });
  });
})();
